"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BgPicker = function BgPicker(props) {
  var field = props.field,
    options = props.options,
    thumbnailStyle = props.thumbnailStyle;
  var value = typeof props.value === 'string' ? props.value : field.value;
  var onChange = props.onChange || field.onChange;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames2["default"])(_style["default"].frameWrapper, _style["default"].scrollView)
  }, options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("label", {
      key: option.value,
      className: (0, _classnames2["default"])(_style["default"].frame, _defineProperty({}, _style["default"].selected, option.value === value)),
      onClick: function onClick() {
        return onChange(option.value);
      }
    }, option.renderPickerItem ? option.renderPickerItem() : /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].thumbnail,
      style: _objectSpread({
        backgroundImage: "url(".concat(option.thumbnail, ")")
      }, thumbnailStyle)
    }), option.label && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].label
    }, option.label));
  }));
};
BgPicker.propTypes = {
  field: _propTypes["default"].object.isRequired,
  options: _propTypes["default"].array,
  thumbnailStyle: _propTypes["default"].object,
  value: _propTypes["default"].string,
  onChange: _propTypes["default"].func
};
BgPicker.defaultProps = {
  thumbnailStyle: {}
};
var _default = exports["default"] = BgPicker;